import * as types from '../mutation-types'
import customersRepository from '../../api/customersRepository'

const state = {
    customerToCreate: {},
    customerToEdit: {},
    customerToUpdate: {},
    customers: [],
    customer: {},
    createdCustomer: {},
    isCustomerCreated: false,
    isCustomerUpdated: false,
    isCustomerDeleted: false
}

const getters = {
    customerToCreate: state => state.customerToCreate,
    customerToEdit: state => state.customerToEdit,
    customerToUpdate: state => state.customerToUpdate,
    customers: state => state.customers,
    customer: state => state.customer,
    createdCustomer: state => state.createdCustomer,
    isCustomerCreated: state => state.isCustomerCreated,
    isCustomerUpdated: state => state.isCustomerUpdated,
    isCustomerDeleted: state => state.isCustomerDeleted
}

const actions = {
    getCustomers({ commit }) {
        return customersRepository.getCustomers().then((response) => {
            commit(types.SET_CUSTOMERS, response.data)
        })
    },
    getCustomer({ commit }, customerId) {
        return customersRepository.getCustomer(customerId).then((response) => {
            commit(types.SET_CUSTOMER, response.data)
        })
    },
    createCustomer({ commit }) {
        return customersRepository.createCustomer(state.customerToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_CUSTOMER_CREATED, true)
                commit(types.SET_CREATED_CUSTOMER, response.data.message)
                commit(types.ADD_CUSTOMER_TO_CUSTOMERS, response.data.message)
            } else {
                commit(types.SET_CUSTOMER_CREATED, false)
            }
        })
    },
    editCustomer({ commit }) {
        return customersRepository.editCustomer(state.customerToEdit).then((response) => {
            if (response.data.success) {
                commit(types.SET_CUSTOMER_UPDATED, true)
            } else {
                commit(types.SET_CUSTOMER_UPDATED, false)
            }
        })
    },
    deleteCustomer({ commit }, customerId) {
        return customersRepository.deleteCustomer(customerId).then((response) => {
            if (response.data.success) {
                commit(types.SET_CUSTOMER_DELETED, true)
            } else {
                commit(types.SET_CUSTOMER_DELETED, false)
            }
        })
    },
    toggleCustomerShowPrices({ commit }) {
        return customersRepository.toggleCustomerShowPrices(state.customerToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.SET_CUSTOMER_UPDATED, true)
            } else {
                commit(types.SET_CUSTOMER_UPDATED, false)
            }
        })
    },
    toggleCustomerAddProducts({ commit }) {
        return customersRepository.toggleCustomerAddProducts(state.customerToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.SET_CUSTOMER_UPDATED, true)
            } else {
                commit(types.SET_CUSTOMER_UPDATED, false)
            }
        })
    },
}

const mutations = {
    [types.SET_CUSTOMER_TO_CREATE](state, payload) {
        state.customerToCreate = payload
    },
    [types.SET_CUSTOMER_TO_EDIT](state, payload) {
        state.customerToEdit = payload
    },
    [types.SET_CUSTOMER_TO_UPDATE](state, payload) {
        state.customerToUpdate = payload
    },
    [types.SET_CUSTOMERS](state, payload) {
        state.customers = payload
    },
    [types.SET_CUSTOMER](state, payload) {
        state.customer = payload
    },
    [types.SET_CREATED_CUSTOMER](state, payload) {
        state.createdCustomer = payload
    },
    [types.SET_CUSTOMER_CREATED](state, payload) {
        state.isCustomerCreated = payload
    },
    [types.SET_CUSTOMER_UPDATED](state, payload) {
        state.isCustomerUpdated = payload
    },
    [types.SET_CUSTOMER_DELETED](state, payload) {
        state.isCustomerDeleted = payload
    },
    [types.ADD_CUSTOMER_TO_CUSTOMERS](state, payload) {
        state.customers.push(payload)
    },
    [types.REMOVE_CUSTOMER_FROM_CUSTOMERS](state, payload) {
        state.customers.forEach((customer, index) => {
            if (customer.id === payload) {
                state.customers.splice(index, 1)
            }
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
